module.exports = __webpack_public_path__ + "img/icon-money.654d9b91.svg";